<mat-card>
  <mat-card-header>
    <mat-card-title>Регистрация</mat-card-title>
  </mat-card-header>
  <form class="registration-form" [formGroup]="form" (ngSubmit)="onSubmit()">
    <mat-form-field *ngIf="groups" appearance="outline">
      <mat-label><mat-icon>group</mat-icon> Кто вы?</mat-label>
      <mat-select placeholder="Выберите роль" formControlName="group">
        <mat-option *ngFor="let group of groups" [value]="group.id">
          {{ group.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field hintLabel="* Обязательно." appearance="outline">
      <mat-label><mat-icon>person</mat-icon> Логин</mat-label>
      <input matInput #login placeholder="ваш логин" formControlName="login">
      <mat-error *ngIf="form.controls.login.invalid">Некоректный логин</mat-error>
    </mat-form-field>

    <mat-form-field hintLabel="* Обязательно. Пример формата example@mail.ru" appearance="outline">
      <mat-label><mat-icon>mail</mat-icon> Email</mat-label>
      <input matInput #email placeholder="your email" formControlName="email">
      <mat-error *ngIf="form.controls.email.invalid">* Обязательное поле. Пример формата example@mail.ru</mat-error>
    </mat-form-field>

    <mat-form-field hintLabel="* Обязательно." appearance="outline">
      <mat-label><mat-icon>security</mat-icon> Пароль</mat-label>
      <input matInput #password placeholder="Ваш пароль" [type]="hide ? 'password' : 'text'" formControlName="password">
      <button class="icon-button" mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
        [attr.aria-pressed]="hide">
        <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
      </button>
    </mat-form-field>
    <hr>
    <button
      class="registration-form__button"
      mat-raised-button
      color="primary"
      [disabled]="!form.valid">Зарегистрироваться</button>
  </form>
  <hr>
  <div class="extra-link">
    <span>Уже есть аккаунт?</span>
    <span><a [routerLink]="['/login']">Войти</a></span>
  </div>
</mat-card>
